import React, { useEffect, useRef } from 'react'

import './SiteCheckbox.scss'

interface SiteCheckboxProps {
  readonly id: number | string,
  readonly checkboxValue: 'checked' | 'unchecked' | 'indeterminate',
  readonly entityNameForIds?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>, clickOnCheckmark: boolean) => void
}

const SiteCheckbox: React.FC<SiteCheckboxProps> = props => {
  const {
    id,
    checkboxValue,
    entityNameForIds,
    onChange
  } = props

  const checkboxRef = useRef<HTMLInputElement>(null)
  const checkmarkRef = useRef<HTMLDivElement>(null)
  const clickOriginRef = useRef<EventTarget | null>(null)

  const handleMouseDown = (e: React.MouseEvent) => {
    clickOriginRef.current = e.target
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const wasExactCheckmarkClick = clickOriginRef.current === checkmarkRef.current
    onChange(e, wasExactCheckmarkClick)
    clickOriginRef.current = null
  }

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = checkboxValue === 'indeterminate'
    }
  }, [checkboxValue])

  const preventDefault = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault()
  }

  return (
    <label
      className="SiteCheckbox"
      onMouseDown={handleMouseDown}
    >
      <input
        ref={checkboxRef}
        type="checkbox"
        id={`${entityNameForIds || 'label'}_${id}`}
        checked={checkboxValue === 'checked'}
        onChange={handleChange}
        onClick={preventDefault}
      />
      <div className="SiteCheckbox__checkmark-wrapper">
        <div
          className="SiteCheckbox__checkmark"
          ref={checkmarkRef}
        />
      </div>
    </label>
  )
}

export default SiteCheckbox
